export const REVIEW_REPORTS_REQUESTED = 'REVIEW_REPORTS_REQUESTED';
export const REVIEW_REPORTS_SUCCESS = 'REVIEW_REPORTS_SUCCESS';
export const REVIEW_REPORTS_FAILED = 'REVIEW_REPORTS_FAILED';
